<template>
	<div>
		<div class="mileage-summary u-container">
			<dl>
				<dt>적립 마일리지</dt>
				<dd>{{ useMileage }}</dd>
				<dt>
					소멸 예정<br />
					마일리지
				</dt>
				<dd>{{ extinAmt }}</dd>
			</dl>
		</div>
	</div>
</template>

<script>
import { numberWithCommas } from '@/utils/util';
import { fetchMileage } from '@/api';

export default {
	data() {
		return {
			// mileage: {},
			useMileage: '',
			extinAmt: '',
		};
	},
	computed: {
		userId() {
			return this.$store.state.userStore.user.user_id;
		},
	},
	methods: {
		async renderMileage() {
			const params = {
				userId: this.userId,
			};

			const { data } = await fetchMileage(params);

			if (data.code === '00000') {
				// this.mileage = data.mileage;
				this.useMileage = numberWithCommas(data.mileage.USE_MILEAGE);
				this.extinAmt = numberWithCommas(data.mileage.EXTIN_AMT);
			}
		},
	},
	created() {
		this.renderMileage();
	},
};
</script>

<style scoped>
.mileage-summary {
	padding: 1rem 0 1.875rem;
}

.mileage-summary dl {
	display: flex;
	border-top: 2px solid #222;
}

.mileage-summary dt,
.mileage-summary dd {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 2.625rem;
	border: 1px solid #c8c8c8;
	border-right-width: 0;
	border-top: 0;
}

.mileage-summary dd:last-child {
	border-right-width: 1px;
}

.mileage-summary dt {
	flex: 0 0 24%;
	color: #666;
	font-size: 0.6875rem;
}

.mileage-summary dd {
	flex: 1;
	color: #222;
	font-size: 0.75rem;
	font-weight: 700;
}
</style>
